import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { displayModal } from '@xanadu/ui-shared/modules/modal/actions';
import ReviewAccountActivity from '@xanadu/ui-shared/components/ReviewAccountActivity';
import { updateAndNotifyAccountActivityFrequency, clearAccountActivityFrequencyError } from '@xanadu/ui-shared/modules/accountActivity/actions';

const mapDispatchToProps = {
  displayModal,
  updateAndNotifyAccountActivityFrequency,
  clearAccountActivityFrequencyError
};

function mapStateToProps(state) {
  return {
    editState: state.getIn(['accountActivity', 'frequency', 'editState']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReviewAccountActivity));
